__turbopack_context__.v({
  "accordionSlideOverwrite": "termsAndConditions-module-scss-module__7YUNZW__accordionSlideOverwrite",
  "card": "termsAndConditions-module-scss-module__7YUNZW__card",
  "description": "termsAndConditions-module-scss-module__7YUNZW__description",
  "fadeIn": "termsAndConditions-module-scss-module__7YUNZW__fadeIn",
  "fadeOut": "termsAndConditions-module-scss-module__7YUNZW__fadeOut",
  "scaleIn": "termsAndConditions-module-scss-module__7YUNZW__scaleIn",
  "scaleOut": "termsAndConditions-module-scss-module__7YUNZW__scaleOut",
  "title": "termsAndConditions-module-scss-module__7YUNZW__title",
  "zoomIn": "termsAndConditions-module-scss-module__7YUNZW__zoomIn",
  "zoomOut": "termsAndConditions-module-scss-module__7YUNZW__zoomOut",
});
